import { Box, Divider, DrawerBody } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { Drawer } from '~/components/Drawer';

import { useAdvancedFiltersStore } from '../../store/useAdvancedFilterStore';
import { useCreatorsFiltersStore } from '../../store/useCreatorsFiltersStore';
import { ClearAllFiltersButton } from '../ClearAllFiltersButton';
import { AgeFilter } from './AgeFilter';
import { GenderFilters } from './GenderFilters';
import { LocationFilter } from './LocationFilter';
import { PerformanceMetrics } from './PerformanceMetrics/PerformanceMetrics';
import { PLATFORM_OPTIONS, PlatformsToggle } from './PlatformsToggle';

export function FiltersDrawer() {
  const { activePlatform, isDrawerOpen, setIsDrawerOpen, clearFilters } =
    useAdvancedFiltersStore();

  const { clearAllFilters } = useCreatorsFiltersStore();

  const handleClearFilters = useCallback(() => {
    clearAllFilters();
    clearFilters();
  }, [clearAllFilters, clearFilters]);

  return (
    <Drawer
      isOpen={isDrawerOpen}
      title="Audience Filters"
      onClose={setIsDrawerOpen.bind(null, false)}
      onOverlayClick={setIsDrawerOpen.bind(null, false)}
      contentProps={{
        width: '100%',
        maxWidth: { base: '100%', md: '360px' },
      }}
    >
      <DrawerBody height="80vh" paddingX={0} paddingTop={0}>
        <Box
          background="white"
          position="sticky"
          top={0}
          zIndex="100"
          paddingX="24px"
          paddingY="8px"
        >
          <PlatformsToggle />
        </Box>

        <Box marginX="24px">
          <GenderFilters />
          <Divider marginX={0} marginY={5} width="auto" />

          <AgeFilter />
          <Divider marginX={0} marginY={5} width="auto" />

          <LocationFilter />
          <Divider marginX={0} marginY={5} width="auto" />

          {activePlatform !== PLATFORM_OPTIONS.snapchat &&
            (activePlatform as string) !== PLATFORM_OPTIONS.selectPlatform && (
              <>
                <PerformanceMetrics />
                <Divider marginX={0} marginY={5} width="auto" />
              </>
            )}

          <ClearAllFiltersButton onClear={handleClearFilters} />
        </Box>
      </DrawerBody>
    </Drawer>
  );
}
